import React, { useContext } from 'react'
import { ConfigContext } from '../ConfigContext'

export default function useConfigContext() {
  return useContext(ConfigContext)
}
